import { render, staticRenderFns } from "./charts.vue?vue&type=template&id=52e2b30f&scoped=true&"
import script from "./charts.vue?vue&type=script&lang=js&"
export * from "./charts.vue?vue&type=script&lang=js&"
import style0 from "./charts.vue?vue&type=style&index=0&id=52e2b30f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e2b30f",
  null
  
)

export default component.exports